/*
 * Zoom for the pictures of the /cart sofa pieces list (snippets/kc-cart-sofa.liquid).
 *
 * Any element with `data-zoom-src` opens that image full size in a <dialog>. One delegated listener on the document,
 * so it keeps working after the cart section re-renders (quantity changes, pickup toggle…) without re-binding.
 * Click on the picture, the backdrop or ✕, or press Escape, to close.
 */
(() => {
  if (window.__kcImageZoom) return;
  window.__kcImageZoom = true;

  let dialog = null;

  const ensureDialog = () => {
    if (dialog) return dialog;
    dialog = document.createElement("dialog");
    dialog.className = "kc-zoom";
    dialog.innerHTML =
      '<button type="button" class="kc-zoom__close" aria-label="Close">&times;</button>' +
      '<img class="kc-zoom__image" alt="">';
    dialog.addEventListener("click", () => dialog.close());
    document.body.appendChild(dialog);
    return dialog;
  };

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest?.("[data-zoom-src]");
    if (!trigger) return;
    event.preventDefault();
    const d = ensureDialog();
    const img = d.querySelector("img");
    img.src = trigger.getAttribute("data-zoom-src");
    img.alt = trigger.getAttribute("data-zoom-alt") || "";
    d.showModal();
  });
})();
